import http from "~/common/http";

export default {

    getList(params) {
        return http.get('/api/customer-quote/index', {
            params: params
        });
    },

    create(data) {
        return http.post("/api/customer-quote/create", data);
    },

    update(data) {
        return http.put("/api/customer-quote/update", data);
    },

    delete(id) {
        return http.delete("/api/customer-quote/delete", {
            params: {
                id: id
            }
        });
    }


}


// WEBPACK FOOTER //
// ./src/services/CustomerQuote.js